const messages = {
    root: {
        pageTitle: 'Prepress',
        menuTitle: 'Prepress'
    },
    jobs: {
        pageTitle: 'Raportowanie zleceń',
        menuTitle: 'Raportowanie zleceń',
        listTitle: 'Lista zleceń',
        table: {
            headers: {
                number: 'Numer zlecenia',
                platesAmount: 'Ilość montaży',
                status: 'Status',
                actions: 'Akcje'
            }
        },
        jobPlatesTable: {
            headers: {
                plateNumber: 'Numer montażu',
                paper: 'Papier',
                colour: 'Kolorystyka',
                machine: 'Maszyna',
                done: 'Wykonane',
                previews: 'Podglądy',
                actions: 'Akcje'
            }
        },
        actions: {
            open: 'Otwórz',
            close: 'Zamknij',
            cancel: 'Anuluj',
            execute: 'Wykonaj',
            download: 'Pobierz'
        },
        dialogs: {
            jobPlatesTitle: 'Lista montaży dla zlecenia {jobNumber}',
            trolleyNumberTitle: 'Numer wózka',
            trolleyNumberLabel: 'Numer',
            trolleyNumberRequired: 'Numer wózka jest wymagany.'
        },
        errors: {
            fetchJobs: 'Pobranie listy zleceń nie powiodło się.',
            fetchAggregatedJobs: 'Pobranie maszyn z zadaniami nie powiodło się.',
            fetchJobPlates: 'Pobranie montaży nie powiodło się.',
            reportJobPlate: 'Zaraportowanie zlecenia nie powiodło się.'
        },
        notifications: {
            reportSuccess: 'Zlecenie zostało zaraportowane.'
        }
    },
    plateOrders: {
        pageTitle: 'Płyty dodatkowe',
        menuTitle: 'Płyty dodatkowe',
        listTitle: 'Lista zamówień',
        filters: {
            hideDone: 'Ukryj wykonane'
        },
        table: {
            headers: {
                jobNumber: 'Numer zlecenia',
                plateNumber: 'Montaż',
                symbol: 'Symbol maszyny',
                createdAt: 'Data utworzenia',
                createdBy: 'Utworzone przez',
                actions: 'Akcje'
            }
        },
        actions: {
            open: 'Otwórz',
            delete: 'Usuń',
            save: 'Zapisz',
            close: 'Zamknij',
            turnSignalOff: 'Wyłącz alarm'
        },
        dialog: {
            title: 'Zlecenie: {jobNumber} Montaż: {plateNumber} Maszyna: {machineCode}',
            orderDate: 'Data zamówienia:',
            createdBy: 'Zamawiający:',
            itemsTable: {
                headers: {
                    plateCode: 'Kod płyty',
                    colour: 'Kolor',
                    side: 'Strona',
                    checked: 'Wykonana',
                    checkedBy: 'Wykonana przez',
                    checkedDate: 'Data wykonania',
                    actions: 'Akcje'
                }
            },
            reasonsTable: {
                headers: {
                    reason: 'Przyczyna zamówienia'
                }
            }
        },
        confirmations: {
            turnSignalOff: {
                title: 'Wyłączanie alarmu',
                content: 'Czy na pewno chcesz wyłączyć alarm?',
                confirm: 'Potwierdź'
            },
            deletePlateOrderItem: {
                title: 'Usuwanie płyty',
                content: 'Czy na pewno chcesz usunąć płytę?',
                confirm: 'Usuń'
            }
        },
        errors: {
            fetchPlateOrders: 'Pobranie listy zamówień nie powiodło się.',
            fetchPlateOrder: 'Pobranie danych dla zamówienia {id} nie powiodło się.',
            fetchPlateOrderItem: 'Pobranie danych dla płyty {id} nie powiodło się.',
            savePlateOrder: 'Zapis nie powiódł się.',
            deletePlateOrderItem: 'Usunięcie płyty nie powiodło się.',
            turnSignalOff: 'Wyłączenie alarmu nie powiodło się.'
        },
        notifications: {
            saveSuccess: 'Zapis powiódł się.',
            deletePlateOrderItemSuccess: 'Płyta została usunięta.',
            turnSignalOffSuccess: 'Alarm został wyłączony.'
        }
    }
}

export default {
    messages,
    locale: 'pl'
}
